module.exports = __webpack_public_path__ + "static/media/caret-circle-right.be0f822e.svg";